import { useMemo } from 'react'
import { getCachedResourceList } from 'src/utils/resourceCache'

/**
 * Reads recently-cached calls/messages/numbers from localStorage
 * (populated at login by LoadResourcesAll() in src/provider.js — see
 * src/views/pages/login/Login.js). No network requests are made here.
 *
 * The read only happens when `open` is true, and is memoized against
 * `open` so re-renders while the palette stays open (e.g. on every
 * keystroke) don't re-parse localStorage JSON.
 *
 * @param {boolean} open - Whether the command palette is currently open
 * @returns {{ numbers: Array, calls: Array, messages: Array }}
 */
export function useRecentSearchData(open) {
  return useMemo(() => {
    if (!open) {
      return { numbers: [], calls: [], messages: [] }
    }

    return {
      numbers: getCachedResourceList('numbers'),
      calls: getCachedResourceList('calls'),
      messages: getCachedResourceList('messages'),
    }
  }, [open])
}
